import { create } from "zustand";

// A store because the watcher that detects a stale tab lives in the root layout while the banner that reports it lives in the application layout. There is no way back to false: only a reload fixes a stale tab, and a reload resets the store.
export const useIsTabStale = create<{
  isTabStale: boolean;
  markTabStale: () => void;
}>()((set) => ({
  isTabStale: false,
  markTabStale: () => set({ isTabStale: true }),
}));
